.summary {
  margin: 0;
  font-size: var(--t-dense);
}

.list {
  list-style: none;
  margin: 4px 0 0;
  padding: 0;
  display: grid;
  gap: 2px;
  font-size: var(--t-dense);
}

.item {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 8px;
  align-items: baseline;
}

.state {
  color: var(--muted);
}

.link {
  color: var(--accent);
  text-decoration: underline;
  text-underline-offset: 2px;
}

.failed {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 12px;
  align-items: baseline;
  font-size: var(--t-dense);
}

.retry {
  font: inherit;
  color: var(--accent);
  background: none;
  border: 0;
  padding: 0;
  text-decoration: underline;
  text-underline-offset: 2px;
  cursor: pointer;
}

.raise {
  margin: 6px 0 0;
  font-size: var(--t-dense);
}
